import { UpdateQuizAnswerInBatchAnswer } from "@/requests/questionnaries/update-quiz-answer-in-batch.request";
import { Choice, ChoiceType, DimensionGroup } from "@/types/questionnaries";

export const mapDimensionGroupToLabel = (group: DimensionGroup) => {
  switch (group) {
    case "GENERAL_INFORMATION":
      return "Información general";
    case "IMPACT_DIMENSIONS":
      return "Dimensiones de impacto";
    default:
      return "";
  }
};

/**
 * Gets a list of UpdateQuizAnswerInBatchAnswer objects from a tree of
 * choices recursively. Choice type COMPOSITE is not sent to the backend, only its children.
 *
 */
export const mapChoiceToRequests = (
  choice: Choice,
): Array<UpdateQuizAnswerInBatchAnswer> => {
  const requests: Array<UpdateQuizAnswerInBatchAnswer> = [];

  if (choice.type === ChoiceType.Composite) {
    choice.choices.forEach((child) => {
      requests.push(
        ...mapChoiceToRequests(child).map((answer) => ({
          ...answer,
          choiceId: answer.choiceId,
        })),
      );
    });
  } else {
    requests.push({
      choiceId: choice.id,
      value:
        choice.type === ChoiceType.Fillable ? choice.answerValue : undefined,
      action: choice.selected ? "ADD" : "REMOVE",
    });
  }

  return requests;
};
